// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-page {
  background: #ffffff;
  color: #000000;
  padding: 2rem 1.5rem;
  margin-top: 10vh;
  margin-bottom: 5vh;

}

.product-detail-page .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: 1px solid #000000;
  color: #000000;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 2rem;
  transition: all 0.2s ease;
}

.back-button:hover {
  background: #000000;
  color: #ffffff;
  border-color: #000000;
  transform: translateX(-2px);
}

.product-detail-wrapper {

  max-width: 1400px;
  border-radius: 12px;
  border: 1px solid #000000;
  background: #ffffff;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.product-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  min-height: 800px;
}

.product-detail-image {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  height: 100%;
}

.product-detail-image img {
  height: 100%;
  object-fit: cover;
}

.product-detail-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;

}

.product-category {
  display: inline-flex;
  border: 1px solid #000000;
  background: #ffffff;
  color: #000000;
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;
  width: fit-content;
}

.product-header {
  margin-bottom: 1.5rem;
}

.product-header h1 {
  font-size: clamp(1.8rem, 3.5vw, 2.8rem);
  margin: 0.5rem 0 0;
  color: #000000;
  line-height: 1.2;
  font-weight: 700;
}

.product-section {
  margin-bottom: 2rem;
}

.product-section h3 {
  font-size: 1.1rem;
  margin: 0 0 1rem;
  color: #000000;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.product-main-description {
  margin: 0 0 0.8rem;
  color: #333333;
  font-size: 1rem;
  line-height: 1.7;
}

.product-extended-description {
  margin: 0;
  color: #333333;
  font-size: 0.95rem;
  line-height: 1.7;
}

.features-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.8rem;
}

.features-list li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #333333;
  font-size: 0.95rem;
}

.features-list li svg {
  width: 20px;
  height: 20px;
  color: #000000;
  flex-shrink: 0;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.detail-item h4 {
  margin: 0 0 0.5rem;
  font-size: 0.9rem;
  color: #555555;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.detail-item p {
  margin: 0;
  font-size: 1rem;
  color: #000000;
  font-weight: 500;
}

.product-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-primary,
.btn-secondary {
  flex: 1 1;
  padding: 0.85rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #000000;
  color: #ffffff;
}

.btn-primary:hover {
  background: #333333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.btn-secondary {
  background: transparent;
  color: #000000;
  border: 2px solid #000000;
}

.btn-secondary:hover {
  background: #000000;
  color: #ffffff;
  border-color: #000000;
}

.product-not-found {
  text-align: center;
  padding: 4rem 2rem;
}

.product-not-found h1 {
  font-size: 2.5rem;
  margin: 0 0 1rem;
  color: #000000;
}

.product-not-found p {
  margin: 0 0 2rem;
  color: #333333;
  font-size: 1.05rem;
}

@media (max-width: 1024px) {
  .product-detail-grid {
    grid-template-columns: 1fr;
  }

  .product-detail-image .image-container {
    min-height: 350px;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .product-detail-content {
    padding: 1.5rem;
  }

  .product-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .product-section {
    margin-bottom: 1.5rem;
  }

  .product-header h1 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .product-detail-page .container {
    padding: 0 1rem;
  }

  .product-detail-content {
    padding: 1rem;
  }

  .product-section h3 {
    font-size: 1rem;
  }

  .product-header h1 {
    font-size: 1.5rem;
  }

  .details-grid {
    gap: 1rem;
  }
}




.features-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.55rem;
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 999px;
  background: #1A1A1A;
}

.product-actions {
  margin-top: 1rem;
}

.btn-primary {
  width: 100%;
  border-radius: 999px;
  border: 1px solid #1A1A1A;
  background: #1A1A1A;
  color: #fff;
  padding: 0.72rem 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background: #333;
  border-color: #333;
}

@media (max-width: 1024px) {
  .product-detail-grid {
    grid-template-columns: 1fr;
  }

  .product-detail-image .image-container {
    min-height: 350px;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .product-detail-content {
    padding: 1.5rem;
  }

  .product-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .product-section {
    margin-bottom: 1.5rem;
  }

  .product-header h1 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .product-detail-page .container {
    padding: 0 1rem;
  }

  .product-detail-content {
    padding: 1rem;
  }

  .product-section h3 {
    font-size: 1rem;
  }

  .product-header h1 {
    font-size: 1.5rem;
  }

  .details-grid {
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/productDetail.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;;;;AAKA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".product-detail-page {\n  background: #ffffff;\n  color: #000000;\n  padding: 2rem 1.5rem;\n  margin-top: 10vh;\n  margin-bottom: 5vh;\n\n}\n\n.product-detail-page .container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 !important;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: transparent;\n  border: 1px solid #000000;\n  color: #000000;\n  padding: 0.6rem 1rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  margin-bottom: 2rem;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background: #000000;\n  color: #ffffff;\n  border-color: #000000;\n  transform: translateX(-2px);\n}\n\n.product-detail-wrapper {\n\n  max-width: 1400px;\n  border-radius: 12px;\n  border: 1px solid #000000;\n  background: #ffffff;\n  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n}\n\n.product-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n  min-height: 800px;\n}\n\n.product-detail-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000;\n  height: 100%;\n}\n\n.product-detail-image img {\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-detail-content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: #ffffff;\n\n}\n\n.product-category {\n  display: inline-flex;\n  border: 1px solid #000000;\n  background: #ffffff;\n  color: #000000;\n  border-radius: 999px;\n  padding: 0.35rem 0.8rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 600;\n  width: fit-content;\n}\n\n.product-header {\n  margin-bottom: 1.5rem;\n}\n\n.product-header h1 {\n  font-size: clamp(1.8rem, 3.5vw, 2.8rem);\n  margin: 0.5rem 0 0;\n  color: #000000;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.product-section {\n  margin-bottom: 2rem;\n}\n\n.product-section h3 {\n  font-size: 1.1rem;\n  margin: 0 0 1rem;\n  color: #000000;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.product-main-description {\n  margin: 0 0 0.8rem;\n  color: #333333;\n  font-size: 1rem;\n  line-height: 1.7;\n}\n\n.product-extended-description {\n  margin: 0;\n  color: #333333;\n  font-size: 0.95rem;\n  line-height: 1.7;\n}\n\n.features-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.8rem;\n}\n\n.features-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: #333333;\n  font-size: 0.95rem;\n}\n\n.features-list li svg {\n  width: 20px;\n  height: 20px;\n  color: #000000;\n  flex-shrink: 0;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n}\n\n.detail-item h4 {\n  margin: 0 0 0.5rem;\n  font-size: 0.9rem;\n  color: #555555;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n.detail-item p {\n  margin: 0;\n  font-size: 1rem;\n  color: #000000;\n  font-weight: 500;\n}\n\n.product-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  flex: 1;\n  padding: 0.85rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background: #000000;\n  color: #ffffff;\n}\n\n.btn-primary:hover {\n  background: #333333;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: #000000;\n  border: 2px solid #000000;\n}\n\n.btn-secondary:hover {\n  background: #000000;\n  color: #ffffff;\n  border-color: #000000;\n}\n\n.product-not-found {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.product-not-found h1 {\n  font-size: 2.5rem;\n  margin: 0 0 1rem;\n  color: #000000;\n}\n\n.product-not-found p {\n  margin: 0 0 2rem;\n  color: #333333;\n  font-size: 1.05rem;\n}\n\n@media (max-width: 1024px) {\n  .product-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .product-detail-image .image-container {\n    min-height: 350px;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-detail-content {\n    padding: 1.5rem;\n  }\n\n  .product-actions {\n    flex-direction: column;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n  }\n\n  .product-section {\n    margin-bottom: 1.5rem;\n  }\n\n  .product-header h1 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .product-detail-page .container {\n    padding: 0 1rem;\n  }\n\n  .product-detail-content {\n    padding: 1rem;\n  }\n\n  .product-section h3 {\n    font-size: 1rem;\n  }\n\n  .product-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .details-grid {\n    gap: 1rem;\n  }\n}\n\n\n\n\n.features-list li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.55rem;\n  width: 0.35rem;\n  height: 0.35rem;\n  border-radius: 999px;\n  background: #1A1A1A;\n}\n\n.product-actions {\n  margin-top: 1rem;\n}\n\n.btn-primary {\n  width: 100%;\n  border-radius: 999px;\n  border: 1px solid #1A1A1A;\n  background: #1A1A1A;\n  color: #fff;\n  padding: 0.72rem 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n  background: #333;\n  border-color: #333;\n}\n\n@media (max-width: 1024px) {\n  .product-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .product-detail-image .image-container {\n    min-height: 350px;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-detail-content {\n    padding: 1.5rem;\n  }\n\n  .product-actions {\n    flex-direction: column;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n  }\n\n  .product-section {\n    margin-bottom: 1.5rem;\n  }\n\n  .product-header h1 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .product-detail-page .container {\n    padding: 0 1rem;\n  }\n\n  .product-detail-content {\n    padding: 1rem;\n  }\n\n  .product-section h3 {\n    font-size: 1rem;\n  }\n\n  .product-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .details-grid {\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
